var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.start
    ? _c(
        "div",
        {
          class: [
            "over_body_mask",
            _vm.finish && _vm.dim ? "over_body_mask_after" : "",
          ],
          style: _vm.setStyle(),
          on: { click: _vm.close },
        },
        [
          _c(
            "div",
            {
              class: [
                "over_body_dialog",
                _vm.before,
                _vm.finish ? _vm.after : "",
              ],
              style: _vm.setStyle(_vm.dialogStyle),
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [_vm._t("default")],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }